export default "/assets/images/dark-moss-sm.fbe91d9411cf0c47.jpg";